export class Loader {
    static showLoader(form) {
        $(form).append(`
            <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="spinner_overlay"></div>
        `);
    }

    static hideLoader(form) {
        $(form).find('.spinner').remove();
        $(form).find('.spinner_overlay').remove();
    }
}